module.exports = __webpack_public_path__ + "static/media/wmgr_sample_bottle.06d220de.png";